<template>
  <div id="app">
    <van-popup
      v-model="visible"
      :close-on-click-overlay="false"
      :style="{ height: '100%', overflow: 'hidden' }"
    >
      <div class="popup-container">
        <router-view />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("App.mounted");
    this.gInit();
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    async init() {},
  },
};
</script>

<style>
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.popup-container {
  overflow-y: auto;
  height: 100%;
}
.van-popup {
  width: 840px;
  height: 100vh;
}
@media screen and (max-width: 480px) {
  .van-popup {
    width: 100%;
  }
}
/* :root {
  --Color1: orange;
  --Color2: v-bind(sGetConfig("color2"));
  --Color3: v-bind(sGetConfig("color1"));
} */

:root {
  --van-number-keyboard-close-color: orange;
}
:root:root {
  /* --van-button-primary-background: red; */
  --van-tabbar-height: 4rem;
  /* --van-dialog-radius:0; */
  /* --van-popup-padding:0; */
  --van-stepper-input-font-size: 2rem;
  --van-primary-color: purple;
  --van-danger-color: orange;
  /* --van-default-color:green; */
  /* --van-text-color:pink; */
}
.C1 {
  color: v-bind(sGetConfig("color1"));
}
.C2 {
  color: v-bind(sGetConfig("color2"));
}
.C3 {
  color: v-bind(sGetConfig("color3"));
}
.C4 {
  color: #f56c6c;
}

.fx08 {
  font-size: 0.8rem;
}
.fx12 {
  font-size: 1.2rem;
}
.fx13 {
  font-size: 1.3rem;
}
.fx14 {
  font-size: 1.4rem;
}
.fx16 {
  font-size: 1.6rem;
}

.note {
  background-color: #eee;
  padding: 0.3rem;
}

.tag {
  /* border-radius: 1rem; */
  padding: 0.2rem;
  line-height: 2rem;
  margin-top: 0.5rem;
  background-color: #f56c6c;
  font-size: 0.8rem;
  color: white;
}

.msg {
  color: v-bind(sGetConfig("color1"));
  background-color: white;
  min-height: 5rem;
}

.HideScrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE and Edge */

.HideScrollbar {
  -ms-overflow-style: none;
  overflow: hidden;
}

.shadow {
  box-shadow: 3px 1px 10px #8f8f8f;
  -webkit-box-shadow: 3px 1px 10px #8f8f8f;
  -moz-box-shadow: 3px 1px 10px #8f8f8f;
}
</style>
